import i18n from '@/libs/i18n/index'
import useEntityCrud from '@/composable/useEntityCrud'
import useEntityHelper from '@/composable/useEntityHelper'
import useErrorManager from '@/composable/useErrorManager'
import { ref } from '@vue/composition-api'

export default function useThemeSettingsList() {
  const MODULE_NAME = 'theme-settings'
  const ENDPOINT = 'setting'

  const { getAlt } = useEntityHelper()
  function convertResource(resource, selectedLang) {
    const value = resource.value && resource.value[selectedLang]
    return {
      ...resource,
      title: resource.title[selectedLang],
      value,
      lang: selectedLang,
      phrase: resource.type === 'phrase' ? value : '',
      richText: resource.type === 'richText' ? value : '',
      settingFile: resource.fileId ? resource.fileId[selectedLang] : '',
      settingFileAlt: getAlt('fileId', resource, selectedLang),
    }
  }
  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)

  const errorManager = useErrorManager()

  const themeSettingTypes = ref(['file', 'phrase', 'richText'])
  const tableColumns = [
    {
      key: 'title', label: i18n.t('general.title'), sortable: true, type: 'truncate-text', width: 100,
    },
    { key: 'type', label: i18n.t('general.type') },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), sortable: true, type: 'dateTime',
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), sortable: true, type: 'dateTime',
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  return {
    ...entity,
    convertResource,
    errorManager,
    tableColumns,
    themeSettingTypes,
  }
}
